
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Tabs, Tab, Typography } from '@material-ui/core'
import MessageDisplayAreaWrapper from './message-display-area-wrapper/MessageDisplayAreaWrapper.jsx'
import InformationLine from './InformationLine.jsx'
import ExpansionInformation from './ExpansionInformation.jsx'
import {
  ChangeColorDarkIcon, ChangeColorLightIcon, IPIcon, LogoutIcon,
} from '../../../components/icons/index.js'
import DownloadChatButton from './download-chat/DownloadChat.jsx'
import SendToEmail from './send-to-email/SendToEmail.jsx'
import RemoveTranscript from './remove-transcript/RemoveTranscript.jsx'

import * as loginActions from '../../login/loginActions.js'
import * as appActions from '../../../store/actions/appActions.js'

import './TranscriptPreview.scss'

const TranscriptPreview = ({
  account, transcript, colorTheme, texts, selectColorTheme, logout, history, isHideSelectedTranscript,
}) => {
  const {
    transcriptId, startChatForm, visitor, chatLength, messagesInChat, postChatSurvey,
  } = transcript || {};
  const [subpage, setSubpage] = useState('transcript');
  const handleChangeSubpage = (event, newValue) => setSubpage(newValue);
  const messageDisplayAreaRef = useRef(null);

  const preChatSurveyFields = {}
  if (startChatForm) {
    const keysNotFields = ['Browser/OS:', 'Called From:', 'Host Name:', 'IP Address:', 'Referrer:', 'op']
    Object.keys(startChatForm).forEach(key => {
      if (keysNotFields.indexOf(key) === -1) {
        preChatSurveyFields[key] = startChatForm[key];
      }
    })
  }

  function switchColorTheme() {
    selectColorTheme(colorTheme === 'lightBlue' ? 'darkMode' : 'lightBlue');
  }

  function handleLogout() {
    logout(history);
  }

  // function clearCache() {
  //   window.localStorage.clear();
  //   window.location.reload();
  // }

  const isShow = transcriptId && !isHideSelectedTranscript;

  return (
    <div className="transcriptPreview">
      {/* <div className="topSidebar" onClick={clearCache}>Clear cache!!!</div> */}
      <div className="topSidebar">
        {/* <PSTranscriptsLogoIcon /> */}
        <LogoutIcon onClick={handleLogout} />
        <Typography className="accountName">{account.accountName}</Typography>
        <div className="space" />
        {
          colorTheme === 'lightBlue'
            ? <ChangeColorDarkIcon onClick={switchColorTheme} />
            : <ChangeColorLightIcon onClick={switchColorTheme} />
        }
      </div>

      { !isShow && <Typography className="plug">{texts['transcript-not-selected']}</Typography> }


      { isShow &&
        <Tabs value={subpage} onChange={handleChangeSubpage} aria-label="simple tabs example">
          <Tab disabled={!transcript.messages} label={texts['transcript']} value="transcript" />
          <Tab disabled={!transcript.messages} label={texts['client-data']} value="client_data" />
        </Tabs>
      }

      { isShow && subpage === 'transcript' &&
        <div className="subpage subpage_transcript">
          <div className="basicTranscriptInformation">
            <InformationLine
              description={texts['started']}
              value={transcript.startDate && new Date(transcript.startDate).toLocaleString()}
            />
            <InformationLine
              description={texts['finished']}
              value={transcript.endDate && new Date(transcript.endDate).toLocaleString()}
            />
            <InformationLine description={texts['assigned-operator']} value={transcript.assignedOperator?.nickname} />
            <InformationLine description={texts['accepted-operator']} value={transcript.acceptedOperator?.nickname} />
            <InformationLine description={texts['invited-operator']} value={transcript.invitedOperatorNicknames} />

            <DownloadChatButton
              transcript={transcript}
              messageDisplayAreaRef={messageDisplayAreaRef}
              texts={texts}
              accountName={account.accountName}
            />
            <SendToEmail transcriptId={transcriptId} />
            <RemoveTranscript transcriptId={transcriptId} />
          </div>

          <MessageDisplayAreaWrapper transcript={transcript} messageDisplayAreaRef={messageDisplayAreaRef} />
        </div>
      }

      {isShow && subpage === 'client_data' &&
        <div className="subpage subpage_clientData custom-scroll">
          <ExpansionInformation
            title={texts['pre-chat-survey']}
            fields={Object.keys(preChatSurveyFields).map(key => [key, preChatSurveyFields[key]])}
          />
          <ExpansionInformation
            title={texts['general']}
            fields={[
              [texts['called-from'], visitor && visitor.calledFrom
                    && (<a href={visitor.calledFrom} target="_blank" rel="noopener noreferrer">{visitor.calledFrom}</a>)],
              [texts['chat-length'], chatLength],
              [texts['messages-in-chat'], messagesInChat],
            ]}
          />

          <ExpansionInformation
            title={texts['post-chat-survey']}
            fields={Object.entries(postChatSurvey || {}).map(([key, value]) => {
              let text = texts[key.toLowerCase().replace(/\s+/g, '-')] || key
              return [text, value]
            })}
          />

          {visitor && visitor.userAgent
            ? <ExpansionInformation
              title={texts['technology']}
              separator=""
              fields={[
                [
                  <img
                    src={`/img/browser-icons/${visitor.userAgent.browserName.toLowerCase().replace(/ /g, '-')}-@2x.png`}
                    alt="browser"
                  />,
                  `${visitor.userAgent.browserName}${visitor.userAgent.browserVersion
                    ? ` ${visitor.userAgent.browserVersion}`
                    : ''
                  }`,
                ],
                [<img src={`/img/os-icons/${visitor.userAgent.osName.toLowerCase().replace(/ /g, '-')}-@2x.png`} alt="os" />,
                  `${visitor.userAgent.osName}${visitor.userAgent.osVersion ? ` ${visitor.userAgent.osVersion}` : ''}`],
                [<IPIcon />, visitor.ipAddress],
                ['userAgent', visitor.userAgent.str],
              ]}
            />
            : null
              }
        </div>
      }
    </div>
  )
}

TranscriptPreview.propTypes = {
  account: PropTypes.object.isRequired,
  transcript: PropTypes.object,
  isHideSelectedTranscript: PropTypes.bool.isRequired,
  colorTheme: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  selectColorTheme: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    transcript: state.transcriptViewer.preview.transcript,
    isHideSelectedTranscript: state.transcriptViewer.isHideSelectedTranscript,
    colorTheme: state.app.colorTheme,
    texts: state.app.texts,
    account: state.app.account,
  }), dispatch => bindActionCreators({
    selectColorTheme: appActions.selectColorTheme,
    logout: loginActions.logout,
  }, dispatch),
)(TranscriptPreview);
